import { Component, OnInit } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { UserService } from '../../services/userService';
import { TestService } from '../../services/test.service';
import { User } from '../../models/User';
import { Test } from '../../models/Test';
@Component({
  selector: 'app-user-list',
  standalone: true,
  imports: [RouterLink, RouterOutlet],
  templateUrl: './user-list.component.html',
  styleUrl: './user-list.component.css'
})
export class UserListComponent implements OnInit {
  Users: User[] = [];
  Tests: Test[] = [];
  StartingWith: string = 'A';
  letters: string[] = ("0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ").split('');
  constructor(private userService: UserService, private testService: TestService) { }

  ngOnInit() {
    this.loadUsers();
  }

  loadUsers() {
    this.userService.getUsers(this.StartingWith).subscribe(data => { this.Users = data; });
  }

  updateStartingWith(s: string) {
    this.StartingWith = s;
    this.loadUsers();
  }

  delete(user: User) {
    this.userService.deleteUser(user).subscribe(data => {
      if (data) {
        this.loadUsers();
      }
    });
  }
}
